"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarksSelectedEvent = void 0;
const api_external_contract_js_1 = require("@tableau/api-external-contract-js");
const TableauWorksheetEvent_1 = require("./TableauWorksheetEvent");
class MarksSelectedEvent extends TableauWorksheetEvent_1.TableauWorksheetEvent {
    constructor(worksheet) {
        super(api_external_contract_js_1.TableauEventType.MarkSelectionChanged, worksheet);
    }
    getMarksAsync() {
        return this.worksheet.getSelectedMarksAsync();
    }
}
exports.MarksSelectedEvent = MarksSelectedEvent;
//# sourceMappingURL=MarksSelectedEvent.js.map